/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTimeEntryTypeBaseResponse
 */
export interface GetTimeEntryTypeBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTimeEntryTypeBaseResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryTypeBaseResponse
     */
    name: string;
}

/**
 * Check if a given object implements the GetTimeEntryTypeBaseResponse interface.
 */
export function instanceOfGetTimeEntryTypeBaseResponse(value: object): value is GetTimeEntryTypeBaseResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetTimeEntryTypeBaseResponseFromJSON(json: any): GetTimeEntryTypeBaseResponse {
    return GetTimeEntryTypeBaseResponseFromJSONTyped(json, false);
}

export function GetTimeEntryTypeBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimeEntryTypeBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
    };
}

export function GetTimeEntryTypeBaseResponseToJSON(json: any): GetTimeEntryTypeBaseResponse {
    return GetTimeEntryTypeBaseResponseToJSONTyped(json, false);
}

export function GetTimeEntryTypeBaseResponseToJSONTyped(value?: GetTimeEntryTypeBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
    };
}

